import { IPaymentCard } from '../types/global/generic.types';

export type SubscriptionPaymentRail = 'stripe' | 'paystack' | 'flutterwave';

/**
 * Cards usable for creator subscribe on a given rail.
 * Prefer explicit `source`; fall back to authorization shape for older Paystack rows.
 */
export function filterPaymentCardsForRail(
    cards: IPaymentCard[] | undefined,
    rail: SubscriptionPaymentRail,
): IPaymentCard[] {
    if (!cards?.length) return [];
    if (rail === 'stripe') {
        return cards.filter(c => !c.source || c.source === 'stripe');
    }
    if (rail === 'flutterwave') {
        return cards.filter(c => c.source === 'flutterwave');
    }
    return cards.filter(c => c.source === 'paystack' || (!c.source && Boolean(c.authorization?.authorization_code)));
}

export function resolveSubscriptionRail(opts: {
    isFlutterwave?: boolean;
    isPaystack?: boolean;
}): SubscriptionPaymentRail {
    if (opts.isFlutterwave) return 'flutterwave';
    if (opts.isPaystack) return 'paystack';
    return 'stripe';
}
